import React, { Component } from 'react';

export default function Breadcrumbs(props) {

    let dynamicBreadcrumb = {"forDashboard":"Dashboard", "forTotalInvoice":"Total Invoice Processed"};

    return (
        <>

            <nav>
                <ul className="breadcrumb-list d-flex align-items-center">
                    <li><a href="#" className='me-2'>Home</a><i className="fas fa-angle-right"></i><i className="fas fa-angle-right"></i></li>
                    <li className="breadcrumb-item active" aria-current="page">{props.title}</li>
                </ul>
            </nav>
        </>

    )
}
